module.exports = function arrayNext(array, currentItem) {
    var len = array.length;
    var newIndex = array.indexOf(currentItem) + 1;
    if (newIndex > (len - 1)) newIndex = 0;
    return array[newIndex];
};



//////////////////
// WEBPACK FOOTER
// ./~/array-next/array-next.js
// module id = 346
// module chunks = 0